import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutIntellirouteCity extends Layout {
    panelMain: Panel;
    sourceIntellirouteCity: DataSource;
    textboxAirportCode: Textbox;
    textboxCounty: Textbox;
    textboxLatitude: Textbox;
    textboxLongitude: Textbox;
    textboxName: Textbox;
    textboxNumber: Textbox;
    textboxStateId: Textbox;
    textboxThreeDigitZip: Textbox;
    textboxTimezoneId: Textbox;
    textboxZipCode: Textbox;
    textboxZoneId: Textbox;
}
